import { render, staticRenderFns } from "./ioc-table.vue?vue&type=template&id=6e208ff4&scoped=true&"
import script from "./ioc-table.vue?vue&type=script&lang=js&"
export * from "./ioc-table.vue?vue&type=script&lang=js&"
import style0 from "./ioc-table.vue?vue&type=style&index=0&id=6e208ff4&prod&scoped=true&lang=scss&"
import style1 from "./ioc-table.vue?vue&type=style&index=1&id=6e208ff4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e208ff4",
  null
  
)

export default component.exports